import React from "react";
import styles from "./ticTacToe.module.scss";

export default function Square(props) {
  return (
    <div className={`${styles.square} ${styles[props.styles]}`} {...props}>
      {props.x ? "x" : props.o ? "o" : ""}
    </div>
  );
}
